import React from "react";
import { AreaChart, Area, ResponsiveContainer } from "recharts";

export default function Sparkline({ data, color }) {
    const id = `sg${color.replace(/[^a-z0-9]/gi,"")}`;
    return (
        <ResponsiveContainer width="100%" height={36}>
            <AreaChart data={data} margin={{ top:2,right:0,bottom:0,left:0 }}>
                <defs>
                    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%"  stopColor={color} stopOpacity={0.3}/>
                        <stop offset="95%" stopColor={color} stopOpacity={0}/>
                    </linearGradient>
                </defs>
                <Area type="monotone" dataKey="v" stroke={color} strokeWidth={1.5}
                    fill={`url(#${id})`} dot={false} isAnimationActive={false}/>
            </AreaChart>
        </ResponsiveContainer>
    );
}
